const lang = {
    ja: {
        'organizerList.placeholder.company': '検索したい{companyName}を入力してください',
        'organizerList.placeholder.product': '検索したい{product}を入力してください',
        'organizerList.tableNote': '出展企業の一覧です。※出展企業の展示品を見たい場合、その会社の「□閲覧企業チェック」の□に✔を入れてください。',
        'organizerList.productTitle': '商品タイトル',
        'organizerList.duration': 'デュレーション',
        'organizerList.productImageVideoAudio': '商品の画・動・音',
        'organizerList.visitorApplication': '入場申込み',
        'organizerList.organizerApplication': '出展申込み',
        'organizerList.loginRequired': '出展企業一覧を閲覧するために、入場者アカウントでログインしてください。',
        'organizerList.14DaysBefore': '開催日14日前よりは出展企業一覧を公開しません。',
        'organizerList.7DaysAfter': '催しの開催時間が終わったから7日後より出展企業一覧を見ることができません。',
        'organizerList.XDaysBefore': '開催日より{XSDiffDAY}日前までは出展企業一覧を公開いたしません。',
        'organizerList.XDaysAfter': '催しの開催終了から{XEDiffDAY}日経過したため出展企業一覧を見ることができません。',
        'organizerPosterList.exhibition': '出展者チェック企業',
        'organizerPosterList.pastEventPeriod': '催しの開催期間内のみに出展者の展示商品の詳細を見ることができます。',

        // new cr 21/01/2021
        'organizerPosterList.exhibitionNewName': '見たい企業リスト',
        'organizerPosterList.listCompany': '見たい企業リスト',
        'organizerBusinessContact.send': '送信',
        'organizerBusinessContact.inquiries': 'お問合せ',
        'organizerBusinessContact.buyOrNegotiate': '買いたい・商談',
        'organizerBusinessContact.enterCompanyOrCompanyName': '社名や氏名を入力して下さい',
        'organizerBusinessContact.descriptionOne': '買いたい　（入力例：',
        'organizerBusinessContact.descriptionTwo': '△△△を２７本、125,000円で買いたい。',
        'organizerBusinessContact.descriptionThree': '売りたい （入力例：',
        'organizerBusinessContact.descriptionFour': '〇〇〇を100個、57,000円で売りたい。',
        'organizerBusinessContact.descriptionFive': '他お問い合わせ　（例：',
        'organizerBusinessContact.descriptionSix': '直径2m/m、長さ15mm,中空直径1.5m/m、材質ステンレスが作れないか。',
    },
    en: {
        'organizerList.placeholder.company': 'Please enter a {companyName} to search.',
        'organizerList.placeholder.product': 'Please enter a {product} to search.',
        'organizerList.productImageVideoAudio': 'Image, video, and sound of product',
        'organizerList.visitorApplication': 'Application for entry',
        'organizerList.organizerApplication': 'Apply for Exhibition',
        'organizerList.14DaysBefore': 'Exhibitor list is not available from 14 days before the exhibition.',
        'organizerPosterList.pastEventPeriod': 'Only during the event period, you can see details of products exhibited by the exhibitors.',

        // new cr 21/01/2021
        'organizerPosterList.exhibitionNewName': 'Favorite company list',
        'organizerPosterList.listCompany': 'Favorite company list',
        'organizerBusinessContact.send': 'Submit',
        'organizerBusinessContact.inquiries': 'Contact',
        'organizerBusinessContact.buyOrNegotiate': 'Want to buy/Business meeting',
        'organizerBusinessContact.enterCompanyOrCompanyName': 'Please enter company name or your name. ',
        'organizerBusinessContact.descriptionOne': 'Want to buy (Example: ',
        'organizerBusinessContact.descriptionTwo': 'We want to buy 27 △△△ for 125,000 yen. ',
        'organizerBusinessContact.descriptionThree': 'Want to sell (Example: ',
        'organizerBusinessContact.descriptionFour': 'We want to sell 100 ○○○ for 57,000 yen. ',
        'organizerBusinessContact.descriptionFive': 'Other (Example: ',
        'organizerBusinessContact.descriptionSix': 'Can you fabricate stainless parts with 2m/m in diameter, 15mm in length and 1.5m/m in hollow diameter?',
    },
};

export default lang;
